import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { DvlaLookupService }           from './dvla-lookup.service';
import { DvlaLookupSettingsComponent } from './dvla-lookup.settings.component';
import { SessionService }              from '../sessions/session.service';

export const DvlaLookupStates : Array<NgHybridStateDeclaration> = [
  {
    component: DvlaLookupSettingsComponent,
    name     : 'app.dvla-lookup',
    resolve  : [
      {
        deps     : [ DvlaLookupService ],
        resolveFn: ( dvlaLookupService : DvlaLookupService ) : number => dvlaLookupService.getAvailableRequests(),
        token    : 'availableRequests'
      },
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : Promise<any> => sessionService.refresh(),
        token    : 'session'
      }
    ],
    url: '/dvla_lookup'
  }
];
